import api from './api'

export interface Story {
  id: number
  user: {
    id: number
    username: string
    firstName: string
    lastName: string
    profileImage?: string
  }
  mediaUrl: string
  thumbnailUrl?: string
  mediaType: 'IMAGE' | 'VIDEO'
  caption?: string
  duration?: number
  viewCount: number
  hasViewed: boolean
  expiresAt: string
  createdAt: string
}

export interface StoryCreateRequest {
  mediaUrl: string
  thumbnailUrl?: string
  mediaType: 'IMAGE' | 'VIDEO'
  caption?: string
  duration?: number
}

const storyService = {
  createStory: async (data: StoryCreateRequest) => {
    const response = await api.post('/stories', data)
    return response.data
  },

  getFeedStories: async () => {
    const response = await api.get('/stories/feed')
    return response.data
  },

  getUserStories: async (userId: number) => {
    const response = await api.get(`/stories/user/${userId}`)
    return response.data
  },

  getStory: async (storyId: number) => {
    const response = await api.get(`/stories/${storyId}`)
    return response.data
  },

  viewStory: async (storyId: number) => {
    const response = await api.post(`/stories/${storyId}/view`)
    return response.data
  },

  deleteStory: async (storyId: number) => {
    const response = await api.delete(`/stories/${storyId}`)
    return response.data
  },

  getAllActiveStories: async () => {
    const response = await api.get('/stories/all')
    return response.data
  },
}

export default storyService